import React, { useState } from "react";
import { TAB_META } from "./helpers";
import MiniWorkbench from "./MiniWorkbench";
import RotatingWord from "./RotatingWord";
import { TabPanelCode, TabPanelEstimate, TabPanelReview } from "./TabPanels";

const TAB_ORDER = ["design", "code", "estimate", "review"];

const ROTATING_PHRASES = ["Design + Cost", "Review + Deploy", "Enforce + Verify"];

export default function Hero() {
  const [activeTab, setActiveTab] = useState("design");

  return (
    <section className="hero hero-tabbed">
      <div className="hero-starfield" aria-hidden="true" />
      <div className="wrap">
        <div className="tabbed-top reveal">
          <h1 className="display tabbed-display tabbed-display-shine">
            <span className="tabbed-line">Control Plane for</span>
            <span className="tabbed-line">Agent Driven Infrastructure</span>
            <span className="tabbed-line tabbed-line-rotating">
              <RotatingWord words={ROTATING_PHRASES} />
            </span>
          </h1>
        </div>

        <div className="tabbed-shell reveal">
          <div className="tabbed-tabs" role="tablist">
            {TAB_ORDER.map((k, i) => (
              <button
                key={k}
                className={"tabbed-tab" + (k === activeTab ? " is-active" : "")}
                role="tab"
                data-tab={k}
                onClick={() => setActiveTab(k)}
              >
                <span className="tabbed-tab-num">{String(i + 1).padStart(2, "0")}</span>
                <span className="tabbed-tab-title">{TAB_META[k].title}</span>
              </button>
            ))}
          </div>

          <div className="tabbed-meta">
            <p className="tabbed-tagline">{TAB_META[activeTab].tagline}</p>
            <p className="tabbed-summary">{TAB_META[activeTab].summary}</p>
          </div>

          <div className="tabbed-stage reveal">
            <MiniWorkbench className={"tabbed-panel" + (activeTab === "design"   ? " is-active" : "")} />
            <TabPanelCode     className={"tabbed-panel" + (activeTab === "code"     ? " is-active" : "")} />
            <TabPanelEstimate className={"tabbed-panel" + (activeTab === "estimate" ? " is-active" : "")} />
            <TabPanelReview   className={"tabbed-panel" + (activeTab === "review"   ? " is-active" : "")} />
          </div>
        </div>
      </div>
    </section>
  );
}
